import { Container } from 'react-bootstrap';
import styled from 'styled-components';
import { useConcurso } from '../../../../../providers/ConcursoProvider';
import { Accordion } from '../../../../Accordion/Accordion';
import { AccordionItem } from '../../../../Accordion/AccordionItem';
import { AccionesConcurso } from '../../../Commons/AccionesConcurso';

import { ComiteTable } from '../Commons/ComiteTable/ComiteTable';
import ListadoActas from '../Commons/ListadoActas/ListadoActas';
import ListadoPuestos from '../Commons/ListadoPuestos';
import TablaCronograma from '../Commons/TablaCronograma/TablaCronograma';

const SpacedContainer = styled(Container)`
  margin-bottom: 2rem;
`;
const ConcursoPublicadoCG = () => {
  const { esCoordinadorConcursal } = useConcurso();
  return (
    <SpacedContainer>
      <Accordion>
        <AccordionItem title="Cronograma">
          <TablaCronograma />
        </AccordionItem>
        <AccordionItem title="Miembros Comité">
          <ComiteTable esCC={esCoordinadorConcursal} />
        </AccordionItem>
        <AccordionItem title="Listado de actas">
          <ListadoActas publicado />
        </AccordionItem>
        <AccordionItem title="Postulaciones">
          <ListadoPuestos />
        </AccordionItem>
      </Accordion>
      <AccionesConcurso />
    </SpacedContainer>
  );
};

export default ConcursoPublicadoCG;
